<template>
    <div class="vx-row match-height">
      <div class="vx-col w-full">
        <vx-card>
          <div class="mb-5" v-if="isConfirmed === 'false'">
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-button
                  type="filled"
                  class="float-right submit-btn"
                  v-has-permission="'GoToConfirmIndividualAgent'"
                  @click.prevent="confirm()"
                  >{{ $t("Confirm") }}</vs-button
                >
                <vs-button
                  type="filled"
                  class="float-right ml-4"
                  id="cancel-btn"
                  v-has-permission="'GoToRejectIndividualAgent'"
                  @click.prevent="reject()"
                  >{{ $t("Reject") }}</vs-button
                >
              </div>
            </div>
          </div>
          <vs-tabs vs-alignment="fixed" alignment="fixed">
            <vs-tab :label="$t('EditAgentInfo')">
              <edit-individual-agent-review></edit-individual-agent-review>
            </vs-tab>
            <vs-tab
              :label="$t('UploadDocuments')"
              v-if="
                $tabHasPermission(
                  'AssignDocument|UnAssignDocument|GetAgentDocuments|GetDocumentSettingsByPartyType'
                )
              "
            >
              <documents-upload-review mode="individual"></documents-upload-review>
            </vs-tab>
            <vs-tab :label="$t('RecipientInfo')">
              <recipient-info-review></recipient-info-review>
            </vs-tab>
          </vs-tabs>
        </vx-card>
      </div>
    </div>
  </template>
  <script>
  import { mapGetters, mapActions } from "vuex";
  import EditIndividualAgentReview from "./EditIndividualAgentReview.vue";
  import RecipientInfoReview from "../../Agents/RecipientInfoReview.vue";
  import DocumentsUploadReview from "../DocumentsUploadReview.vue";
  export default {
    components: {
      EditIndividualAgentReview,
      RecipientInfoReview,
      DocumentsUploadReview,
    },
    data() {
      return {
        isConfirmed: false,
      };
    },
    mounted() {
      this.isConfirmed = this.$route.query.isConfirmed;
    },
    methods: {
      ...mapActions({
        confirmIndividualAgent: "individual/confirmIndividualAgent",
        rejectIndividualAgent: "individual/rejectIndividualAgent",
      }),
      confirm() {
        var id = this.$route.params.id;
        this.confirmIndividualAgent({ agentId: id }).then(() => {
          this.$router.go(-1);
        });
      },
      reject() {
        var id = this.$route.params.id;
        this.rejectIndividualAgent({ agentId: id }).then(() => {
          this.$router.go(-1);
        });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  #cancel-btn {
    background: #fd4c4c !important;
  }
  
  #cancel-btn:hover {
    -webkit-box-shadow: 0 8px 25px -8px #fd4c4c !important;
    box-shadow: 0 8px 25px -8px !important;
    color: #ab6c6c !important;
  }
  </style>
  